<!-- 投放效果跟踪 -->
<template>
<div id="effect">
	<div id="" :style="{'width':table_scroll_width + 'px',}">
	<div :style="{'width':body_width - 60 + 'px',}" style="position: sticky;left: 30px;z-index: 5;">
		<!-- 标题 -->
		<div class="page-title">投放效果跟踪</div>
		
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 10px 0 0;">
			<!-- 2023-1-9日期范围改为后端控制，在用户列表设置 -->
			<!-- <div v-if="role_control.includes(1) || role_control.includes(3)" class="screen-box"> -->
			<div class="screen-box">
				<div class="screen-label">投放日期</div>
				<a-range-picker style="width:300px;" @change="onChangeDate" :allowClear="false"
				:locale="locale" 
				:value="[this.moment(startTime, dateFormat),this.moment(endTime, dateFormat)]" />
			</div>
			<!-- <div v-else class="screen-box">
				<div class="screen-label">投放日期</div>
				<a-range-picker style="width:300px;" @change="onChangeDate" :allowClear="false"
				:locale="locale"
				:value="[this.moment(startTime, dateFormat),this.moment(endTime, dateFormat)]"
				:disabledDate="DateControl"/>
			</div> -->
			
			<div v-if="Object.keys(filterList.op_id).length > 0" class="screen-box">
				<div class="screen-label">投手</div>
				<a-select
					mode="multiple"
					style="min-width: 200px"
					placeholder="请选择投手"
					@change="handleChangeA"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
				  >
					<a-select-option v-for="(item,index) in filterList.op_id.list" :key="index" :value="item.key" >
					  {{item.value}}
					</a-select-option>
				</a-select>
				
			</div>
			
			<div class="screen-box">
				<div class="screen-label">投放书籍</div>
				
				<putBookSelect ref="getPutBook" @handleChangeSelect="handleChangeB"></putBookSelect>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">媒体渠道</div>
				<a-select
					mode="multiple"
					style="min-width: 200px"
					placeholder="请选择媒体渠道"
					@change="handleChangeE"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
				  >
					<a-select-option v-for="(item,index) in filterList.media_id.list" :key="index" :value="item.key">
					  {{item.value}}
					</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">公众号书城</div>
				<a-select
					mode="multiple"
					style="min-width: 200px"
					placeholder="请选择书城"
					@change="handleChangeF"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					:value="r_channel_id"
					allowClear
				  >
					<a-select-option v-for="(value,key) in filterList.gzh_channel.list" :key="key" :value="key">
					  {{value}}
					</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">公众号</div>
				
				<moreSelect 
				 ref="getGzhSelect"
				:placeholder="'请选择公众号'"
				:select_mode="'multiple'"
				@handleChangeSelect="handleChangeGzh"
				></moreSelect>
				
			</div>
			
			<div class="screen-box">
				<div class="screen-label">快应用书城</div>
				<a-select
					style="width: 200px"
					placeholder="请选择书城"
					@change="handleChangeY"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				  >
					<a-select-option v-for="(value,key) in filterList.qk_channel.list" :key="key" :value="key">
					  {{value}}
					</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">快应用推广链接</div>
				
				<kyyLinkSelect ref="getKyyLink" @handleChangeSelect="handleChangeS"></kyyLinkSelect>
				
				<!-- <a-select
				 mode="multiple"
				 style="width: 300px" 
				 placeholder="未选择" 
				 notFoundContent="请先选择快应用书城" 
				 :filter-option="filterOption"
				 @change="handleChangeS"
				 showSearch 
				 :value="r_qk_url"
				 allowClear
				>
					<a-select-option :value="'-1'">全选</a-select-option>
					<a-select-option  v-for="(item,index) in qk_url_data" :key="item.id" :value="item.id" :title="item.text">
						{{item.text}}
					</a-select-option>
				</a-select> -->
			</div>
			
			<div class="screen-box">
				<div class="screen-label">小程序</div>
				<xcxSearchSelect ref="getXcxSelect" :s_width="'200px'" @handleChangeSelect="handleChangeXCX"></xcxSearchSelect>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">作品分类</div>
				
				<a-select
					mode="multiple"
					style="min-width: 180px"
					placeholder="请选择作品分类"
					@change="handleChangeZ"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				  >
					<a-select-option v-for="(item,index) in filterList.book_category.list" :key="item.key" :value="item.key" :title="item.value">
					  {{item.value}}
					</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">频道</div>
				<a-select :value="r_book_type" style="width: 130px;" 
				 @change="handleChangeC" 
				 :getPopupContainer="getsPopupContainer">
					<a-select-option  v-for="(item,index) in filterList.book_type.list" :key="index" :value="item.key">
						{{item.value}}
					</a-select-option>
					  
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">展示维度</div>
				<a-select :value="r_show_type" style="width: 130px;" 
				 @change="handleChangeL" 
				 :getPopupContainer="getsPopupContainer">
					<a-select-option  v-for="(item,index) in filterList.show_type.list" :key="index" :value="item.key">
						{{item.value}}
					</a-select-option>
					  
				</a-select>
			</div>
			
			<a-tooltip placement="bottom">
			    <template slot="title" >
			      最多180天
			    </template>
			    <div class="screen-box">
			    	<div class="screen-label">展示天数</div>
			    	<a-input v-model="r_show_day" placeholder="请输入" type="number" @change="showDayInput" style="width: 120px;"  />
			    </div>
			</a-tooltip>
			
			
			<div class="screen-box">
				<div class="screen-label">排序字段</div>
				<a-select :value="r_sort_key" style="width: 130px;" 
				 @change="handleChangeM" 
				 :getPopupContainer="getsPopupContainer">
					<a-select-option  v-for="(item,index) in sortList.sort_key.list" :key="index" :value="item.key">
						{{item.value}}
					</a-select-option>
					  
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">排序方式</div>
				<a-select :value="r_sort_opt" style="width: 130px;" 
				 @change="handleChangeN" 
				 :getPopupContainer="getsPopupContainer">
					<a-select-option  v-for="(item,index) in sortList.sort_opt.list" :key="index" :value="item.key">
						{{item.value}}
					</a-select-option>
					
				</a-select>
			</div>
			
			<div v-if="filterList.hasOwnProperty('has_money') && (role_control.includes(1) || role_control.includes(3))" class="screen-box">
				<div class="screen-label">有投放或充值</div>
				<a-select :value="r_has_money" style="width: 170px;" 
				 @change="handleChangeO" 
				 :getPopupContainer="getsPopupContainer">
					<a-select-option  v-for="(item,index) in filterList.has_money.list || []" :key="index" :value="item.key">
						{{item.name}}
					</a-select-option>
					  
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">数据录入状态</div>
				
				<a-select
					style="width: 180px"
					placeholder="请选择数据录入状态"
					@change="handleChangeLR"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
					showSearch
				  >
					<template v-if="filterList.hasOwnProperty('has_record') && Object.keys(filterList.has_record).length > 0">
						<a-select-option v-for="(item,index) in filterList.has_record.list || []" :key="item.key" :value="item.key">
						  {{item.name}}
						</a-select-option>
					</template>
				</a-select>
				
			</div>
		</div>
		
		<div style="margin-bottom: 15px;">
			<a-button @click="searchButton" :loading="search_button_loading" type="primary" icon="search" style="margin-right: 20px;">搜索</a-button>
			<a-button @click="exportButton" type="primary" icon="download"  style="margin-right: 20px;">导出</a-button>
			<a-button @click="addListButton" style="background-color: #67c23a;border-color: #67c23a;" type="primary">+ 新增</a-button>
		</div>
	</div>
	</div>
	
	
	
	<!-- 新增的侧边栏 -->
	<a-drawer
	      title="新增"
		  width="600px"
	      placement="right"
	      :closable="false"
	      :visible="visible"
	      @close="onCloseDrawer"
	    >
			<div style="padding: 10px;">
				<div class="form-cell-box">
					<div class="class-title">投放日期</div>
						
					<a-date-picker :value="moment(x_put_date, 'YYYY-MM-DD')" 
					 style="width:340px" @change="onAddChange" 
					 :allowClear="false" placeholder="选择投放日期" 
					  :disabledDate="disabledDate"/>
				</div>
				
				
				
				<div class="form-cell-box">
					<div class="class-title">书城渠道</div>
						
					<a-select :value="x_channel_id" 
					 style="width: 340px" 
					 placeholder="未选择"
					 :filter-option="filterOption"
					 @change="handleChangeH" 
					 showSearch 
					>
						<a-select-option  v-for="(item,index) in filterList.channel_id.list" :key="item.key" :value="item.key">
							{{item.value}}
						</a-select-option>
					</a-select>
				</div>
				
				<div class="form-cell-box">
					<div class="class-title">公众号</div>
						
					<a-select :value="x_gzh_id" 
					 style="width: 340px" 
					 placeholder="未选择" 
					 notFoundContent="没有内容,请先选择书城渠道" 
					 :filter-option="filterOption"
					 @change="handleChangeI"
					 showSearch 
					  >
						<a-select-option  v-for="(item,index) in xz_gzh_data" :key="item.id" :value="item.id" >
							{{item.text}}
						</a-select-option>
					</a-select>
				</div>
				
				<div class="form-cell-box">
					<div class="class-title">媒体渠道</div>
						
					<a-select :value="x_media_id" 
					 style="width: 340px" 
					 placeholder="未选择" 
					 :filter-option="filterOption" 
					 @change="handleChangej" 
					 showSearch
					 >
						<a-select-option  v-for="(item,index) in filterList.media_id.list" :key="index" :value="item.key">
							{{item.value}}
						</a-select-option>
					</a-select>
				</div>
				
				<div class="form-cell-box">
					<div class="class-title">投放书籍</div>
						
					<!-- <a-select :value="x_book_id" 
					 style="width: 340px" 
					 placeholder="未选择"
					 @change="handleChangek" 
					 :filter-option="filterOption"
					 showSearch
					 >
						<a-select-option  v-for="(item,index) in filterList.book_id.list" :key="item.key" :value="item.key">
							{{item.value}}
						</a-select-option>
					</a-select> -->
					<putBookS ref="getPutBookS" @handleChangeSelect="handleChangek"></putBookS>
				</div>
				
				<div class="form-cell-box">
					<div class="class-title">投放金额</div>
						
					<a-input v-model="x_input_money" placeholder="请输入" type="number" style="width: 340px;" prefix="￥" suffix="RMB" />
				</div>
				
				<div style="color: red;height: 23px;width: 100%;">{{add_form_hint}}</div>
				
				<div class="form-cell-box" style="margin-top: 30px;">
					<a-button @click="addRequest" :loading="add_button_loading" type="primary" style="margin-right: 20px;">确认</a-button>
					<a-button @click="onCloseDrawer">取消</a-button>
				</div>
			</div>
			
			
			
	</a-drawer>
	
	<TableEffect @edit-table-cell="editTableCell" :rableTitle="rableTitle"  :tableShowData="tableShowData" 
	 :tableTotalData="tableTotalData" :table_scroll_width="table_scroll_width" 
	  :show_day_control="show_day_control" :day_week_control="day_week_control" 
	  :day_week_width="day_week_width"></TableEffect>

	<!-- 分页 -->
	<!-- <div :style="{'width': table_scroll_width + 'px',}">
		<div style="text-align: center;margin-top: 30px;position: sticky;left: 30px;" :style="{'width': body_width - 60 + 'px',}">
			<a-pagination v-model="r_page" :pageSize="r_limit" :total="table_total" @change="paginationChange" />
		</div>
	</div> -->
	<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="body_width - 60"
	:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
	@pagination-Change="paginationChange" @change-size-limit="changeSizeLimit"></pagingCompont>
	
	
	<a-modal
	      :title="edit_modal_title"
	      :visible="edit_visible"
	      :confirm-loading="confirmLoading"
		  cancelText="取消"
		  okText="确认" 
	      @ok="handleOk"
	      @cancel="handleCancel"
	    >
	    <a-select v-if="edit_modal_title.indexOf('投放渠道') > -1" :value="m_media_id" @change="handleChangeMA" style="width: 200px;font-size: 13px;" >
	        <a-select-option v-for="(item,index) in filterList.media_id.list" :key="index" :value="item.key">
	          {{item.value}}
	        </a-select-option>
	    </a-select>
		  
		<a-input v-else-if="edit_modal_title.indexOf('投放金额') > -1" v-model="m_put_money" placeholder="请输入" type="number"  style="width: 200px;"  />
		
		<!-- <a-select v-else-if="edit_modal_title.indexOf('书籍选择') > -1" :value="m_put_book_id" @change="handleChangeMB" style="width: 200px;font-size: 13px;" >
		    <a-select-option v-for="(item,index) in filterList.book_id.list" :key="index" :value="item.key">
		      {{item.value}}
		    </a-select-option>
		</a-select> -->
		<putBookS v-else-if="edit_modal_title.indexOf('书籍选择') > -1" ref="getPutBookS" @handleChangeSelect="handleChangeMB"></putBookS>
		
		<a-input v-else-if="edit_modal_title.indexOf('新增粉丝') > -1" v-model="m_sub_num" placeholder="请输入" type="number"  style="width: 200px;"  />
	</a-modal>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';

import { putDataMenu, effectList, effectReceiveChannel, effectInfo, effectUpdate, effectExport} from '@/request/api'
import TableEffect from '@/components/putDataTable/TableEffect.vue'
import moreSelect from '@/components/selectCompont/moreSelect.vue'
import kyyLinkSelect from './components/kyyLinkSelect.vue'
import putBookSelect from './components/putBookSelect.vue'
import putBookS from './components/putBookS.vue'
import xcxSearchSelect from '@/components/selectCompont/xcxSearchSelect.vue'
export default {
	name: 'effect_',
	components: {
		TableEffect,moreSelect,kyyLinkSelect,putBookSelect,putBookS,xcxSearchSelect
	},
	data() {
		this.dateFormat = 'YYYY-MM-DD'
		return {
			locale,
			moment,
			startTime: '2020-05-01', // 投放日期-开始时间
			endTime: '2022-06-30', // 投放日期-结束时间
			search_button_loading: false, // 搜索按钮的加载状态
			filterList: { // 搜索条件内容
				media_id:{},
				book_id:{},
				op_id:{},
				channel_id: {},
				gzh_id: {},
				book_type: {},
				show_type: {},
				has_money:{},
				qk_channel: {},
				gzh_channel: {},
				book_category: {},
				
				has_record: {}, // 数据录入状态
			}, 
			sortList: { // 搜索条件内容，另一部分
				sort_key: {},
				sort_opt: {},
			},
			r_put_user_id: [], // 投手
			r_put_book: [], // 投放书籍
			r_media_id: [], // 媒体渠道
			r_channel_id: [], // 书城
			r_gzh_id: [], // 公众号
			r_book_type: 0, // 频道
			r_show_type: "daily", // 展示维度
			r_show_day: 30, // 展示天数
			r_show_week: 8, // 展示周
			r_sort_key: "", // 排序字段
			r_sort_opt: "", // 排序方式
			r_has_money: "", // 有投放或充值
			r_page: 1, // 页数
			r_limit: 100, // 每页多少条
			r_qk_channel_id: undefined, // 快应用书城id
			r_qk_url: [], // 选择的快应用推广链接
			r_book_category: [], // 作品分类
			r_has_record: undefined, // 数据录入状态
			r_appid: undefined, // 选择小程序
			
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID",width:70, sort_status:0,type:"id",show_control: true,sort_:90,sticky_control: true,}, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"投放信息",width:100, sort_status:0,type:"op_name",show_control: false,sort_:89,sticky_control: true,},
				{title:"投放渠道",width:125, sort_status:0,type:"book_name",show_control: false,sort_:88,sticky_control: true,},
				{title:"投放金额",width:110, sort_status:0,type:"book_type",show_control: false,sort_:87,sticky_control: true,},
				{title:"充值信息",width:150, sort_status:0,type:"platform_name",show_control: false,sort_:86,sticky_control: true,},
				{title:"总回报率",width:120, sort_status:0,type:"media_name",show_control: false,sort_:85,sticky_control: true,},
				{title:"书籍选择",width:130, sort_status:0,type:"used_money",show_control: true,sort_:38,sticky_control: false,},
				
				{title:"新增粉丝",width:110, sort_status:0,type:"put_money",show_control: true,sort_:39,sticky_control: false,},
				{title:"支付粉(当天)",width:180, sort_status:0,type:"total_charge_money",show_control: true,sort_:37,sticky_control: false,},
				{title:"支付粉(总计)",width:180, sort_status:0,type:"left_money",show_control: true,sort_:36,sticky_control: false,},
				{title:"复充统计",width:180, sort_status:0,type:"roi",show_control: true,sort_:35,sticky_control: false,},
				
			],
			visible: false, // 新增侧边栏控制
			add_button_loading: false, // 侧边栏新增按钮的loading
			add_form_hint: "", // 侧边栏新增表单的验证提示
			// 新增侧边栏
			x_put_date:"", // 日期选择
			x_input_money: "", // 投放金额
			x_channel_id: undefined, // 书城渠道
			x_gzh_id: undefined, // 公众号
			x_media_id: undefined, // 媒体渠道
			x_book_id: undefined, // 投放书籍
			// 筛选条件盒子宽度，用于粘性定位
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			table_scroll_width: 1500, // 被表格撑开的实际内容宽度
			tableShowData: [], // 表格用来展示的数据
			tableTotalData: {}, // 总计，表格第一行
			show_day_control: 0, // 展示天数的控制
			day_week_control: 'daily', // daily展示天，weekly展示周
			day_week_width: 110, // 展示的单元格宽度
			is_admin: false, // 是否是超级管理员，true为超级管理员，false不是。
			// 新增侧边栏的公众号
			xz_gzh_data: [],
			edit_visible: false, // 编辑弹窗的显示
			edit_modal_title: "", // 编辑弹窗的标题
			confirmLoading: false,
			// 编辑弹窗的内容
			m_put_money: "", // 投放金额
			m_media_id: 0, // 投放渠道的id
			m_put_book_id: 0, // 书籍
			m_sub_num: 0, // 新增粉丝
			m_id: 0, // id
			m_index: 0, // 修改的表格索引
			req_data: [], // 搜索回来的全部数据
			edit_req_data: {}, // 编辑请求的参数
			table_total: 0, // 表格内容总数

			role_control: [], // 用户权限控制
			
			qk_url_data: [], // 选择快应用书城后获取的快应用推广链接
			
			
		}
	},
	mounted(){
		let that = this
		
		this.search_button_loading = true
		
		that.body_width = document.body.clientWidth // 筛选条件大盒子的宽度
		that.table_scroll_width = document.body.scrollWidth // 获取表格内容的宽度
		console.log('document.body.clientWidth',that.body_width,that.table_scroll_width)
		
		// 获取30天前日期
		that.startTime = this.$getBeforeDay(29)
		// that.startTime = this.$getThisDay()
		// 获取当前日期
		that.endTime = this.$getThisDay()
		that.x_put_date = that.endTime
		
		// 获取角色权限
		that.role_control = JSON.parse(localStorage.getItem("role_limits"))
		console.log("role_limits", JSON.parse(localStorage.getItem("role_limits")));

		// 获取小程序下拉
		this.$refs.getXcxSelect.getSelectData()

		putDataMenu().then(res=>{
			console.log('putDataMenu',res)
			if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
				that.filterList = res.data.data.filter
				that.$nextTick(()=>{
					try{
						that.$refs.getGzhSelect.getSelectData(that.filterList.gzh_id.list || [])
					}catch(e){
						that.$refs.getGzhSelect.getSelectData([])
					}
					try{
						that.$refs.getPutBook.getSelectData(that.filterList.book_id.list || [])
					}catch(e){
						that.$refs.getGzhSelect.getSelectData([])
					}
				})
				
				that.sortList = res.data.data.sort
				let f_data = res.data.data.filter
				let s_data = res.data.data.sort
				// console.log('f_data',f_data.book_type.list[0].key)
				that.r_book_type = f_data.book_type.list[0].key, // 频道
				that.r_show_type = f_data.show_type.list[0].key, // 展示维度
				that.r_sort_key = s_data.sort_key.list[0].key, // 排序字段
				that.r_sort_opt = s_data.sort_opt.list[0].key // 排序方式

				// 超级管理、投放管理可以有公众号、投手、有投放或充值
				if(f_data.hasOwnProperty('has_money') && (that.role_control.includes(1) || that.role_control.includes(3))){
					that.r_has_money = f_data.has_money.list[0].key || "" // 有投放或充值。避免报错，加了过滤判断
				}

				that.is_admin = res.data.data.is_admin

				// 搜索
				that.searchButton()

			}
			else {
				that.search_button_loading = false
				if(res.data.code === 401){ // 未登录
					localStorage.removeItem("access_token");
					that.$router.replace({name: 'login',params: {type:'not_log'}})
				}
				else {
					that.$message.error(`错误：${res.data.msg}`);
				}
			}
			// console.log("filterList.hasOwnProperty('has_money')",that.filterList.hasOwnProperty('has_money'))
		})
	},
	methods:{
		// 日期选择
		onChangeDate(date, dateString) {
			console.log(date, dateString);
			this.startTime = dateString[0]
			this.endTime = dateString[1]
		},
		// 日期范围控制，根据权限来
		DateControl(current){
			return current && current > moment().endOf('day') || current < moment().subtract(90, 'day');
		},
		// 新增侧边栏的日期选择。设置今天以后的日期不可选
		disabledDate(current) {
		  return current && current > moment().endOf("day");
		},
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		// 投手
		handleChangeA(value) {
		    console.log(`selected ${value}`);
			// 这里接收的value参数就是一个数组
			this.r_put_user_id = value
		},
		filterOption(input, option) {
			console.log(option.componentOptions.children[0].text);
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 投放书籍
		handleChangeB(value) {
			this.r_put_book = value
		    console.log(`selected ${value}`);
		},

		// 媒体渠道
		handleChangeE(value) {
			this.r_media_id = value
		    console.log(`selected ${value}`);
		},

		// 书城
		handleChangeF(value) {
			this.r_channel_id = value
		    console.log(`selected ${value}`);
		},

		// 公众号
		handleChangeGzh(value) {
			this.r_gzh_id = value
		    console.log(`selected ${value}`);
		},

		// 频道
		handleChangeC(value) {
			this.r_book_type = value
		    console.log(`selected ${value}`);
		},
		// 展示维度
		handleChangeL(value) {
			this.r_show_type = value
		    console.log(`selected ${value}`);
		},
		// 排序字段
		handleChangeM(value) {
			this.r_sort_key = value
		    console.log(`selected ${value}`);
		},
		// 排序方式 
		handleChangeN(value) {
			this.r_sort_opt = value
		    console.log(`selected ${value}`);
		},
		// 有投放或充值
		handleChangeO(value) {
			this.r_has_money = value
		    console.log(`selected ${value}`);
		},
		handleChangeLR(e){ // 数据录入
			this.r_has_record = e
		},
		
		// 新增侧边栏的操作
		// 书城渠道
		handleChangeH(value){
			let that = this
			this.x_channel_id = value
			console.log(`selected ${value}`);
			let r_data = {
				q:value
			}
			effectReceiveChannel(r_data).then(res=>{
				console.log("获取公众号",res)
				that.xz_gzh_data = res.data
			})
		},
		// 公众号
		handleChangeI(value){
			this.x_gzh_id = value
			console.log(`selected ${value}`);
		},
		// 媒体渠道
		handleChangej(value){
			this.x_media_id = value
			console.log(`selected ${value}`);
		},
		// 投放书籍
		handleChangek(value){
			this.x_book_id = value
			console.log(`selected ${value}`);
		},
		
		// 快应用书城
		handleChangeY(e){
			let that = this
			
			this.r_qk_channel_id = e
			this.r_qk_url = []
			if(!e){
				this.$refs.getKyyLink.clearValue()
			}
			else {
				this.$refs.getKyyLink.getSelectData(e)
			}
			
			// effectReceiveChannel({
			// 	q: e
			// }).then(res=>{
			// 	console.log("获取公众号",res)
			// 	that.qk_url_data = res.data
			// })
		},
		// 快应用推广链接
		handleChangeS(e){
			// console.log("快应用推广链接",e);
			this.r_qk_url = e
		},
		// 作品分类
		handleChangeZ(e){
			console.log("作品分类",e);
			this.r_book_category = e
		},
		
		// 选择小程序
		handleChangeXCX(e){
			this.r_appid = e
		},
		
		// 搜索
		searchButton(type){
			let that = this
			console.log("that.r_show_day",that.r_show_day || 0)
			this.search_button_loading = true
			
			if(type != '分页'){
				that.r_page = 1
			}
			
			// 展示天数控制
			if(this.r_show_day){
				this.show_day_control = Number(this.r_show_day)
			}
			else {
				this.show_day_control = 0
			}
			// 展示维度
			this.day_week_control = that.r_show_type
			
			// 表格宽度计算
			let z_w = 0
			that.rableTitle.forEach((res,index)=>{
				z_w = z_w + res.width
			})
			if(that.r_show_type === 'daily'){
				z_w = z_w + 30 + this.day_week_width*this.show_day_control
				that.table_scroll_width = z_w
			}
			else {
				z_w = z_w + 30 + this.day_week_width*8 // 只显示8周
				that.table_scroll_width = z_w
			}
			console.log("that.r_channel_id",that.r_channel_id)
			console.log("that.r_gzh_id",that.r_gzh_id)
			
			// console.log("that.table_scroll_width",that.table_scroll_width)
			
			let r_data = {
				cur_page: that.r_page,
				per_page: that.r_limit,
				
				start_date_key: that.startTime.replace(/-/g, ''),
				end_date_key: that.endTime.replace(/-/g, ''),
				
				book_type: that.r_book_type.toString(), // 频道
				show_type: that.r_show_type, // 展示维度
				sort_key: that.r_sort_key, // 排序字段
				sort_opt: that.r_sort_opt, // 排序方式
				
				// channel_id: that.r_channel_id, // 书城
				// gzh_id: that.r_gzh_id, // 公众号
				media_id: that.r_media_id, // 媒体渠道
				put_book: that.r_put_book, // 投放书籍
				
				book_category: that.r_book_category, // 作品分类
				
				has_record: that.r_has_record, // 数据录入状态
				
				appid: that.r_appid,
			}
			if(that.r_qk_channel_id){ // 快应用书城有内容，跟公众号书城字段合并
				let arr = JSON.parse(JSON.stringify(that.r_channel_id)) || []
				arr.push(that.r_qk_channel_id)
				r_data.channel_id = arr
			}
			else {
				r_data.channel_id = that.r_channel_id
			}
			if(that.r_qk_url){ // 快应用推广链接有内容，跟公众号字段合并
				let arr = JSON.parse(JSON.stringify(that.r_gzh_id)) || []
				// console.log("that.r_qk_url",that.r_qk_url);
				// arr.concat(that.r_qk_url) // concat这里没生效
				for(let i = 0;i < that.r_qk_url.length; i++){
					arr.push(that.r_qk_url[i])
				}
				// console.log("arr",arr);
				r_data.gzh_id = arr
			}
			else {
				r_data.gzh_id = that.r_gzh_id
			}

			// 超级管理、投放管理可以有公众号、投手、有投放或充值。2022-11-1公众号权限放开
			if(that.role_control.includes(1) || that.role_control.includes(3)){
				// r_data.gzh_id = that.r_gzh_id, // 公众号
				r_data.has_money = that.r_has_money.toString() // 有投放或充值
			}
			// op_id字段有内容，则显示投手选择框，并且允许请求
			if(Object.keys(that.filterList.op_id).length > 0){
				r_data.put_user_id = that.r_put_user_id // 投手
			}


			console.log('搜索请求',r_data)
			if(type != '导出'){
				effectList(r_data).then(res=>{
					console.log('搜索结果',res)
					that.search_button_loading = false
					that.table_total = res.data.data.total || 0
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
						that.$message.success('搜索成功');
						if(res.data.data.data.length === 0){
							that.tableTotalData = {}
							that.tableShowData = []
						}
						else {
							let req_data = JSON.parse(JSON.stringify(res.data.data.data))
							
							// console.log("req_data",req_data)
							// 总计数据的处理
							let z_data = req_data[0]
							// console.log("z_data",z_data)
							
							// 把后端返回的数据处理成表格要显示的，针对天数的处理
							function handleData(h_data,show_number){
								// console.log("show_number",show_number)
								// if(that.r_show_type === 'daily'){ // 天
									if(show_number){ // 如果有天数要显示的话
									// console.log("如果有天数要显示的话")
										if(h_data.hasOwnProperty('stats_info')){ // 有这个内容的话，就要判断哪些天是有数值的，哪些天是没有数值的
											let k_data = Object.keys(h_data.stats_info)
											let f_data = [] // 过滤出来能用的放里面
											k_data.forEach((res,indx)=>{ // 过滤，有的键名会是负值，要把负值的去掉
												if(res.indexOf("-") < 0){
													f_data.push(res)
												}
											})
											// console.log("k_data",k_data)
											// console.log("f_data",f_data)
											let nnn = Number(show_number)
											// console.log("nnn",nnn)
											// 把要放入表格显示的数据弄一份出来
											let t_data = [] // 要用来放入表格显示的内容
											for(let i = 0;i<nnn;i++){
												// console.log(333333333)
												let obj = {
													show_type_control: false, // 控制显示有内容的部分还是显示默认的充值：0，false为显示充值：0
													show_value: {}, // 为空，默认显示充值：0
												}
												t_data.push(obj)
											}
											// 然后针对有内容的天数进行处理，把对应天数的数据放进去
											t_data.forEach((res,index)=>{
												f_data.forEach((res_f,index_f)=>{
													if(res_f == index){
														// console.log(555555)
														res.show_type_control = true
														res.show_value = h_data.stats_info[res_f]
													}
												})
											})
											// console.log("t_data",t_data)
											
											// h_data.table_day = t_data
											return t_data
										}
										else { // 没有这个字段的话，直接全部显示“充值：0”
											let nnn = Number(show_number)
											// console.log("nnn",nnn)
											// 把要放入表格显示的数据弄一份出来
											let t_data = [] // 要用来放入表格显示的内容
											for(let i = 0;i<nnn;i++){
												// console.log(333333333)
												let obj = {
													show_type_control: false, // 控制显示有内容的部分还是显示默认的充值：0，false为显示充值：0
													show_value: {}, // 为空，默认显示充值：0
												}
												t_data.push(obj)
											}
											// h_data.table_day = t_data
											return t_data
										}
									}
									else { 
										// h_data.table_day = []
										return []
									}
								// }
								
							}
							
							let ss_nn 
							if(that.r_show_type === 'daily'){ 
								ss_nn = that.r_show_day
							}
							else {
								ss_nn = 8
							}
							z_data.table_day = handleData(z_data, ss_nn)
							that.tableTotalData = z_data
							
							
							
							let s_data = req_data.slice(1,req_data.length)
							
							that.req_data = s_data
							
							s_data.forEach((res,index)=>{
								res.table_day = handleData(res, ss_nn)
								// 处理第一天是否要显示“达标”、“未达标”
								// book_return_require字段和today_return_require字段好像是一样的
								if(res.today_return_require > 0){ // 先保证设置了首日roi
									//  第一天的roi 大于 作品设置的roi
									// if(z_data.table_day[0].show_value.incr > res.today_return_require){  // 达标
										if(res.is_over_roi_require){ // is_over_roi_require这个字段好像只有0、1两个值，0表示不达标。1表示达标
											res.table_day[0].db = '1' // 达标
										}
										else {
											res.table_day[0].db = '2' // 不达标
										}
										
									// }
								}
								
								// true为显示正常内容，false显示编辑操作
								// res.media_name_control = true 
								// res.put_money_control = true
								
							})
							// console.log("s_data",s_data)
							that.tableShowData = s_data
						}
					}
					else {
						that.search_button_loading = false
						if(res.data.code === 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
					}
				})
				.catch(err=>{
					that.search_button_loading = false
					that.$message.error(`错误：${err}`);
				})
			}
			else if(type == '导出'){
				// 这里是直接导出，不用加参数
				// r_data.excel_type = 1
				delete r_data.cur_page
				delete r_data.per_page
				
				effectExport(r_data).then(res=>{
					console.log("导出测试",res);
					that.search_button_loading = false
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){ 
						
						that.$message.success(res.data.msg || "导出成功");
						
					}
					else {
						
						if(res.data.code == 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
						
					}
				})
			}
		},
		// 新增
		addListButton(){
			let that = this
			
			that.visible = true
			that.$nextTick(()=>{
				that.$refs.getPutBookS.getSelectData(that.filterList.book_id.list || [])
			})
		},
		// 侧边栏删除
		onCloseDrawer(){
			if(this.add_button_loading){ // 新增中或编辑中不准关闭侧边栏
				return
			}
			let that = this
			that.visible = false
		},
		// 新增的确认按钮
		addRequest(){
			let that = this
			// console.log('x_channel_id',this.x_channel_id);
			// console.log('x_gzh_id',this.x_gzh_id);
			// console.log('x_media_id',this.x_media_id);
			// console.log('x_book_id',this.x_book_id);
			if(!that.x_put_date){ // 没有投放日期
				that.add_form_hint = "请填写 投放日期 ！！！"
			}
			else if(!that.x_book_id){ // 投放书籍-新增
				that.add_form_hint = "请填写 投放书籍 ！！！"
			}
			else if(!that.x_channel_id){ // 没有书城渠道
				that.add_form_hint = "请填写 书城渠道 ！！！"
			}
			
			else if(!that.x_media_id){ // 媒体渠道-新增
				that.add_form_hint = "请填写 媒体渠道 ！！！"
			}
			else if(!that.x_gzh_id){ // 公众号-新增
				that.add_form_hint = "请填写 公众号 ！！！"
			}
			else if(that.x_input_money.length === 0){ // 投放金额-新增/编辑版
				that.add_form_hint = "请填写 投放金额 ！！！"
			}
			else {
				that.add_form_hint = ""
				that.add_button_loading = true
				let r_data = {
					channel_id: that.x_channel_id, // 书城渠道
					gzh_id: that.x_gzh_id, // 公众号
					media_id: that.x_media_id, // 媒体渠道
					date_key: that.x_put_date, // 投放日期
					put_money: that.x_input_money, // 投放金额
					put_book: that.x_book_id, // 投放书籍
				}
				effectInfo(r_data).then(res=>{
					console.log("新增",res)
					that.add_button_loading = false
					if(res.data.code == 0){
						that.$message.success('新增成功');
						that.visible = false
						
						// 重新搜索一边
						that.searchButton()
						
						that.x_channel_id = undefined // 书城渠道
						that.x_gzh_id = undefined // 公众号
						that.x_media_id = undefined // 媒体渠道
						// that.x_book_id = undefined // 投放书籍。这个不清楚是因为用户再操作的时候会一个书籍连续新增几次，所以不清除，方便用户
						// that.$refs.getPutBookS.getEdit() // 投放书籍下拉框组件，这里面的书籍ID也要清除
						
						that.x_input_money = "" // 投放金额
						
					}
					else {
						if(res.data.code === 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							this.$message.error(res.data.data.message || "新增失败");
						}
					}
				})
				.catch(err=>{
					that.$message.error('新增失败，可能是网络不佳');
					that.add_button_loading = false
				})
			}
		},
		// 导出
		exportButton(){
			let that = this
			// let r_data = {
			// 	start_date_key: that.startTime.replace(/-/g, ''),
			// 	end_date_key: that.endTime.replace(/-/g, ''),
				
			// 	book_type: that.r_book_type.toString(), // 频道
			// 	has_money: that.r_has_money.toString(), // 有投放或充值
			// 	show_type: that.r_show_type, // 展示维度
			// 	sort_key: that.r_sort_key, // 排序字段
			// 	sort_opt: that.r_sort_opt, // 排序方式
			// }

			// let r_url = ""

			// // 超级管理、投放管理可以有公众号、投手、有投放或充值
			// if(that.role_control.includes(1) || that.role_control.includes(3)){
			// 	r_url = `${that.$http.excel_url}api/down/put-data-report?start_date_key=${that.startTime.replace(/-/g, '')}&end_date_key=${that.endTime.replace(/-/g, '')}&book_type=${that.r_book_type}&has_money=${that.r_has_money}&show_type=${that.r_show_type}&sort_key=${that.r_sort_key}`
			// }
			// else { // 非超级管理、投放管理。没有“有投放或充值”
			// 	r_url = `${that.$http.excel_url}api/down/put-data-report?start_date_key=${that.startTime.replace(/-/g, '')}&end_date_key=${that.endTime.replace(/-/g, '')}&book_type=${that.r_book_type}&show_type=${that.r_show_type}&sort_key=${that.r_sort_key}`
			// }
			
			
			// window.open(r_url);
			
			that.searchButton('导出')
		},
		
		// 新增的选择日期
		onAddChange(date, dateString) {
		    console.log(date, dateString);
			this.x_put_date = dateString
		},
		// 给展示天数设置最大值，位数不能超过4位，没有那么多天
		showDayInput(e){
			console.log("this.r_show_day",this.r_show_day)
			// if(this.r_show_day.length > 3){
			// 	let nn = this.r_show_day.slice(0,3)
			// 	if(Number(nn) < 180){
			// 		this.r_show_day = nn
			// 	}
			// 	else {
			// 		this.r_show_day = 180
			// 	}
			// }
			// else {
				let nn = this.r_show_day.slice(0,3) 
				if(Number(nn) < 180){
					this.r_show_day = nn || 0
				}
				else {
					this.r_show_day = 180
				}
			// }
			// console.log("this.show_day_control",this.show_day_control)
			// console.log("this.r_show_day",this.r_show_day)
		},
		
		
		// 编辑
		editTableCell(title,index,value){
			let that = this
			console.log(title)
			console.log(index)
			console.log(value)
			this.edit_modal_title = "编辑" + title
			
			that.m_index = index
			
			// 获取请求要用的id
			that.m_id = that.req_data[index].id
			
			if(title === "投放渠道"){
				
				// console.log(that.req_data)
				let z_data = that.req_data
				z_data.forEach((res_f,index_f) =>{
					if(res_f.media_name === value){
						that.m_media_id = res_f.media_id
					}
				})
			}
			else if(title === "投放金额"){
				that.m_put_money = value
				
			}
			else if(title === "书籍选择"){
				let z_data = that.req_data
				z_data.forEach((res_f,index_f) =>{
					if(res_f.put_book === value){
						that.m_put_book_id = res_f.put_book_id
					}
				})
				
			}
			else if(title === "新增粉丝"){
				that.m_sub_num = value
			}
			this.edit_visible = true;
			if(title === "书籍选择"){
				that.$nextTick(()=>{
					that.$refs.getPutBookS.getSelectData(that.filterList.book_id.list || [])
					that.$refs.getPutBookS.getEdit(that.m_put_book_id)
				})
			}
		},
		handleOk(e) {
		    let that = this
		    this.confirmLoading = true;
		    // setTimeout(() => {
		    //     this.edit_visible = false;
		    //     this.confirmLoading = false;
		    // }, 2000);
			
			let r_data = {
				id: that.m_id
			}
			// that.edit_req_data
			
			if(that.edit_modal_title.indexOf('投放金额') > -1){
				// that.edit_req_data.put_money = that.m_put_money
				r_data.put_money = that.m_put_money
			}
			else if(that.edit_modal_title.indexOf('新增粉丝') > -1){
				// that.edit_req_data.sub_num = that.m_sub_num
				r_data.sub_num = that.m_sub_num
			}
			else if(that.edit_modal_title.indexOf('投放渠道') > -1){
				
				r_data.media_id = that.m_media_id
			}
			else if(that.edit_modal_title.indexOf('书籍选择') > -1){
				// that.edit_req_data.sub_num = that.m_sub_num
				r_data.put_book = that.m_put_book_id
			}
			
			console.log("that.edit_req_data",that.edit_req_data)
			effectUpdate(r_data).then(res=>{
				console.log("修改結果",res)
				
				
				if(that.edit_modal_title.indexOf('投放金额') > -1){
					that.tableShowData[that.m_index].put_money = that.m_put_money
					this.$message.success('编辑成功');
					// 重新搜索一边。因为这里更新的不光是投放金额的数据，还有充值信息的数据。充值信息的数据是要经过后端那边计算的。计算规则我并不知道
					// that.searchButton()
				}
				else if(that.edit_modal_title.indexOf('新增粉丝') > -1){
					that.tableShowData[that.m_index].sub_num = that.m_sub_num
				}
				else if(that.edit_modal_title.indexOf('投放渠道') > -1){
					console.log("that.filterList.media_id.list",that.filterList.media_id.list)
					that.filterList.media_id.list.forEach((res,index)=>{
						if(res.key === that.m_media_id){
							console.log(res)
							that.tableShowData[that.m_index].media_name = res.value
							that.tableShowData[that.m_index].media_id = res.key
						}
					})
					// that.searchButton() // 后端那边有缓存，重新加载了还是旧的数据，所以干脆不刷新了。
				}
				else if(that.edit_modal_title.indexOf('书籍选择') > -1){
					// that.searchButton() // 后端那边有缓存，重新加载了还是旧的数据，所以干脆不刷新了。
					console.log("that.filterList.book_id.list",that.filterList.book_id.list)
					that.filterList.book_id.list.forEach((res,index)=>{
						if(res.key === that.m_put_book_id){
							console.log(res)
							that.tableShowData[that.m_index].put_book = res.value
							that.tableShowData[that.m_index].put_book_id = res.key
						}
					})
				}
				
				this.confirmLoading = false;
				this.edit_visible = false;
			})
		},
		handleCancel(e) {
		  console.log('Clicked cancel button');
		  if( this.confirmLoading){
			  return
		  }
		  this.edit_visible = false;
		},
		// 投放渠道-编辑
		handleChangeMA(value){
			console.log(value)
			this.m_media_id = value
			// this.edit_req_data.media_id = value
		},
		// 书籍选择-编辑
		handleChangeMB(value){
			console.log(value)
			this.m_put_book_id = value
			// this.edit_req_data.put_book_id
		},
		
		// 分页的页数变化
		paginationChange(e){
			console.log(e)
			this.r_page = e
			this.searchButton('分页')
		},
		changeSizeLimit(e){
			// console.log('每页多少条',e)
			this.r_limit = e
			this.searchButton('button')
		},
		
		
	}
}
</script>

<style scoped>

</style>